import React from "react";
import PropTypes from "prop-types";
import "./safeView.scss";

/** This component is a wrapper around its child component.
 * Which will have common horizontal padding for every component
 */

function SafeView(props) {
  return <div className="common-container">{props.children}</div>;
}

SafeView.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SafeView;
